import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
export var useIsCategoryPageFiltered = function() {
    var _useFilterStore = useFilterStore([
        "activeFilterCount"
    ]), activeFilterCount = _useFilterStore.data.activeFilterCount;
    return activeFilterCount > 0;
};
